import AuthShell from "@/components/landing/auth/AuthShell";
import { useState } from "react";
import { Link } from "react-router-dom";

export default function ForgotPasswordBody() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  function onSubmit(event) {
    event.preventDefault();
    setMessage(
      "If that email exists, a reset link will be sent shortly. Please check your inbox.",
    );
  }

  return (
    <AuthShell
      className="forgot-pws"
      title="Forgot your password?"
      subtitle="Enter your email and we'll help you reset your password."
      footer={
        <p className="mb-0">
          Remembered it? <Link to="/login">Back to sign in</Link>
        </p>
      }>
      <form onSubmit={onSubmit}>
        <div className="single-input">
          <input
            type="email"
            placeholder="Email address"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {message ? <p className="text-success small mb-3">{message}</p> : null}
        <div className="btn-area mt-0 mb-0">
          <button className="cmn-btn" type="submit">
            Send reset instructions
          </button>
        </div>
      </form>
    </AuthShell>
  );
}
